import script from "./HelperResources.vue?vue&type=script&setup=true&lang=js"
export * from "./HelperResources.vue?vue&type=script&setup=true&lang=js"

import "./HelperResources.vue?vue&type=style&index=0&id=e174f79e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e174f79e"]])

export default __exports__